<template>
    <LayoutBase>
        <div class="full-height grid">
            <account-sidebar></account-sidebar>

            <div id="content-wrapper" class="app-position">
                <div class="container-fluid">
                    <div class="row no-gutters">
                        <div class="col-md-2"></div>
                        <div class="col-md-8">
                            <alert v-if="alert.copy" :type="alert.type" :title="alert.title" :copy="alert.copy"></alert>

                            <div class="article-wrapper">
                                <div class="panel">
                                    <header>
                                        <h1>General Settings</h1>
                                    </header>

                                    <div class="form">
                                        <div class="form__group">
                                            <label class="form__label" for="name">Organisation name</label>
                                            <input type="text" id="name" name="name" class="form__control" v-model="account.name">
                                        </div>

                                        <div class="form__group">
                                            <label class="form__label" for="domain">Slug</label>
                                            <input type="text" id="domain" name="domain" class="form__control" v-model="account.domain" disabled="">
                                        </div>

                                        <div class="form__group">
                                            <label class="form__label" for="logo">Logo</label>
                                            <div class="form__image">
                                                <div class="uploaded-files">
                                                    <file-upload name="featured-image-upload" type="logo" label="Add your logo" v-model="account.logo" endpoint="/api/media/logo"></file-upload>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form__group">
                                            <label class="form__label" for="hide_email">Hide email for team members</label>
                                            <input type="checkbox" name="hide_email" v-model="account.hide_email" value="1">
                                        </div>
                                        <div class="form__group">
                                            <label class="form__label" for="homepage_groups">Group to show on the homepage</label>
                                            <fieldset class="form__group" id="homepage_groups">
                                                <ul class="form__control list-unstyled">
                                                    <li v-for="group in groups">
                                                        <input :value="group.id" type="checkbox" v-model="account.homepage_groups">
                                                        <label :for="group.id">{{ group.name }}</label>
                                                    </li>
                                                </ul>
                                            </fieldset>
                                        </div>

                                        <div class="form__group">
                                            <button class="btn btn-primary" v-on:click.stop.prevent="saveSettings">Save Changes</button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                </div>
            </div>
        </div>
    </LayoutBase>
</template>

<script>
    import LayoutBase from '../../layouts/LayoutBase';

    export default {
        components: {
            LayoutBase
        },
        data () {
            return {
                groups: [],
                alert: {
                    type: null,
                    title: null,
                    copy: null
                },
                account: {
                    name : null,
                    logo: null,
                    homepage_groups: []
                },
            }
        },
        created() {
            this.getGroups();
        },
        mounted() {
            this.getAccount();
        },
        methods: {
            getGroups() {
                axios.get('/api/groups').then((response) => {
                    this.groups = response.data;
                    //console.log(this.posts.slice(0, 1));
                }, (response) => {
                    this.error = response;
                });
            },
            getAccount() {
                axios.get('/api/account/').then((response) => {
                    this.account = response.data;
                }, (response) => {
                    this.error = response;
                });
            },
            saveSettings(){
                axios.put('/api/account/general', this.account).then((response) => {
                    this.account = response.data;
                    this.$store.commit('auth/setTeam', response.data);

                    window.scrollTo(0, 0);
                    this.alert.type = 'success';
                    this.alert.copy = [this.account.name + " settings have been updated"];
                }, (response) => {
                    this.error = response;
                });
            }
        },
        // Guard to protect route from none admins
        beforeRouteEnter(to, from, next){
            if (!window.user_can.admin) next('/')
            else next()
        }
    }
</script>
